/*
 * CARRON - coherence panier configurateur "demi-mesure"
 * Le supplement "Personnalisation : un mot" (variant 53363649839451) est un ENFANT VERROUILLE du mug :
 *   - pas de bouton Supprimer ni de quantite propre (masques)
 *   - retirer le mug le retire automatiquement (lignes liees par la propriete _nn_set)
 *   - sa quantite suit celle du mug
 * (La soucoupe assortie, elle, reste supprimable independamment.)
 * Charge globalement (le drawer panier est global) depuis layout/theme.liquid.
 */
(function () {
  var FEE_VARIANT = 53363649839451;
  var SET_PROP = '_nn_set';
  var WORD_PROP = 'Mot';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var feeKeys = [];

  function isFee(it) { return (it.variant_id || it.id) === FEE_VARIANT; }

  function change(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not update the linked engraving');
    });
  }

  /* le mug hote = ligne du meme _nn_set, qui n'est pas le supplement et porte un "Mot" */
  function hostFor(fee, items) {
    var set = fee.properties && fee.properties[SET_PROP];
    if (!set) return null;
    for (var i = 0; i < items.length; i++) {
      var m = items[i];
      if (m === fee || isFee(m)) continue;
      if (m.properties && m.properties[SET_PROP] === set && m.properties[WORD_PROP]) return m;
    }
    return null;
  }

  /* masque quantite + Supprimer des lignes supplement (gere via le mug) */
  function lockRows() {
    for (var i = 0; i < feeKeys.length; i++) {
      var inputs = document.querySelectorAll('input[data-line-key="' + feeKeys[i] + '"]');
      for (var j = 0; j < inputs.length; j++) {
        var box = inputs[j].closest('line-item-quantity');
        if (box) box.style.display = 'none';
      }
    }
  }
  function lockSoon() { lockRows(); setTimeout(lockRows, 300); setTimeout(lockRows, 1400); }

  function reconcile() {
    if (busy) return;
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      feeKeys = [];
      var ops = [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!isFee(it)) continue;
        var set = it.properties && it.properties[SET_PROP];
        if (!set) continue; /* supplement non lie (ancien panier) : ne pas y toucher */
        feeKeys.push(it.key);
        var host = hostFor(it, items);
        if (!host) ops.push({ key: it.key, qty: 0 });                                          /* mug retire -> retire le supplement */
        else if (it.quantity !== host.quantity) ops.push({ key: it.key, qty: host.quantity }); /* quantite suit le mug */
      }
      lockSoon();
      if (!ops.length) return;
      busy = true;
      var p = Promise.resolve();
      ops.forEach(function (op) { p = p.then(function () { return change(op.key, op.qty); }); });
      return p.then(function () {
        busy = false;
        // cart:refresh updates the drawer, but not the server-rendered cart page.
        // Reload only after a successful correction so its lines and total agree.
        if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
        .catch(function () { busy = false; });
    }).catch(function () {});
  }

  var t;
  function relock() { clearTimeout(t); t = setTimeout(lockRows, 60); }

  document.addEventListener('cart:change', reconcile);
  document.addEventListener('cart:refresh', lockSoon);
  document.addEventListener('variant:add', function () { setTimeout(reconcile, 50); });

  if (window.MutationObserver) {
    var mo = new MutationObserver(relock);
    ['cart-drawer', 'cart-notification-drawer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
})();
